"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhone = void 0;
/**
 * Allows you to format a phone number string, in any format into a string with dashes only or with parentheses
 * @param data - the value to start with
 * @param format - either 'dashed', 'numbers' or no format optional params
 * @returns the phone number formatted
 *
 * @example
 * formatPhone('(342) 234- 2343', 'numbers');
 * // returns '3422342343'
 *
 */
function formatPhone(data, format) {
    if (data) {
        // Strip out all non-digit characters
        data = data.toString().replace(/\D/g, '');
        // Add formatting
        if (data.length === 10) {
            switch (format) {
                case 'dashed':
                    data = data.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
                    break;
                case 'numbers':
                    break;
                case undefined:
                default:
                    data = data.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
                    break;
            }
        }
        return data;
    }
    else {
        return 'Invalid phone number';
    }
}
exports.formatPhone = formatPhone;
